export default __webpack_public_path__ + "static/media/hbs-k-blk-banner-1.f23a8c67.jpg";